"use client";

import { useEffect, useState } from "react";

interface DeviceOS {
  isIOS: boolean;
  isAndroid: boolean;
  isMobileDevice: boolean;
}

/**
 * Detects the user's operating system based on the user agent string.
 * Returns safe defaults during SSR (all false), then updates on client.
 *
 * @returns Object with isIOS, isAndroid, and isMobileDevice booleans
 */
export function useDeviceOS(): DeviceOS {
  const [deviceOS, setDeviceOS] = useState<DeviceOS>({
    isIOS: false,
    isAndroid: false,
    isMobileDevice: false,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;

    // iOS detection: iPhone, iPad, iPod, or Mac with touch support (iPad in desktop mode)
    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    // Android detection
    const isAndroid = /Android/.test(userAgent);

    // Mobile device detection
    const isMobileDevice = isIOS || isAndroid;

    setDeviceOS({
      isIOS,
      isAndroid,
      isMobileDevice,
    });
  }, []);

  return deviceOS;
}
